import { get, post, put, remove } from "./utils";

export const department = {
  listType: (parameters, token) => {
    return get("/api/basis/departments/type/", parameters, token);
  },
  list: (parameters, token) => {
    return get("/api/basis/departments/", parameters, token);
  },
  create: (parameters, token) => {
    return post("/api/basis/departments/", parameters, token);
  },
  update: (id, parameters, token) => {
    return put(`/api/basis/departments/${id}/`, parameters, token);
  },
  remove: (id, token) => {
    return remove(`/api/basis/departments/${id}/`, {}, token);
  },
  createUser: (id, parameters, token) => {
    return post(`/api/basis/departments/${id}/add_user/`, parameters, token);
  },
  listUsers: (id, token) => {
    return get(`/api/basis/departments/${id}/list_users/`, {}, token);
  },
  removeUser: (id, parameters, token) => {
    return post(`/api/basis/departments/${id}/delete_user/`, parameters, token);
  },
  detail: (id, token) => {
    return get(`/api/basis/departments/${id}/`, {}, token);
  },
  display: (id, token) => {
    return get(`/api/basis/departments/display`, { department_id: id }, token);
  },
  isExist: (name, token) => {
    return get(`/api/basis/departments/is_exist`, { name }, token);
  },
  listColleague: () => {
    return get("/api/message/messages/my_colleague");
  },
  listTarget: (token) => {
    return get(`/api/basis/departments/target/`, {}, token);
  },
};
